import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { track, EVENT_NAME } from '@leagueplatform/analytics';
import {
  CHALLENGE_CAMPAIGN_TYPE,
  TLP_SCREEN_NAMES,
} from '#constants/analytics.constants.tsx';
import { useGetChallengeByIdData } from '#pages/challenge-landing-page/hooks/use-get-challenge-by-id-data.hook.ts';
import { useChallengesAnalytics } from '#hooks/use-challenges-analytics.hook.tsx';
import { ConfirmationModal } from '#components/confirmation-modal/confirmation-modal.component.tsx';
import { DangerButton } from '@leagueplatform/genesis-commons';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';

export interface LeaveTeamModalProps {
  teamName: string;
  isSettingsDropdownOpen: boolean;
  setIsSettingsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onDismiss: () => void;
  leaveChallengeTeam: () => void;
  isLoading: boolean;
}

export const LeaveTeamModal = ({
  teamName,
  isSettingsDropdownOpen,
  setIsSettingsDropdownOpen,
  onDismiss,
  leaveChallengeTeam,
  isLoading,
}: LeaveTeamModalProps) => {
  const { formatMessage } = useIntl();
  const { teamId, challengeId } = useParams<{
    teamId: string;
    challengeId: string;
  }>();
  const { data: challengeData } = useGetChallengeByIdData();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = () => {
    if (challengeData?.data) {
      track(
        'challenges.button_clicked.challenge_team_settings_modal.leave_team',
        {
          team_id: teamId || '',
          team_name: teamName || '',
          health_campaign_id: challengeId || '',
          health_campaign_name: challengeData.data.title || '',
          health_campaign_type: CHALLENGE_CAMPAIGN_TYPE,
        },
      );
    }
  };
  const onClick = () => {
    leaveChallengeTeam();
    setIsSettingsDropdownOpen(!isSettingsDropdownOpen);
    handleAnalyticsClick();
  };

  return (
    <ConfirmationModal
      heading={formatMessage({ id: 'LEAVE_TEAM_QUESTION' }, { teamName })}
      description={formatMessage(
        { id: 'LEAVE_TEAM_DESCRIPTION' },
        { teamName },
      )}
      isSettingsDropdownOpen={isSettingsDropdownOpen}
      onDismiss={onDismiss}
      onMountAnalytics={() =>
        trackChallengesAnalyticsEvent(EVENT_NAME.SCREEN_LOADED, {
          screen_name: TLP_SCREEN_NAMES.LEAVE_TEAM,
          team_name: teamName,
          team_id: teamId,
        })
      }
    >
      <DangerButton onClick={onClick} isLoading={isLoading}>
        {formatMessage({ id: 'LEAVE' })}
      </DangerButton>
    </ConfirmationModal>
  );
};
